import styled from "styled-components";
import { EmptyState, LedgerSection, LedgerSectionHeader } from "../../components";

export const EmptyMaterialSection = styled(LedgerSection)`
    min-height: 0;
    padding: 16px;
    gap: 12px;
    background: #fff;
`;

export const EmptyMaterialHeader = styled(LedgerSectionHeader)`
    align-items: center;
`;

export const MaterialTitleWithCount = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
`;

export const EmptyMaterialState = styled(EmptyState)`
    min-height: 130px;
    box-sizing: border-box;
    align-items: center;
    text-align: center;
    background: #fff;

    .title {
        font-size: 18px;
        line-height: 24px;
    }

    .body {
        font-size: 14px;
        line-height: 20px;
    }
`;

export const materialCellSx = {
    code: { minWidth: "112px", width: "112px", maxWidth: "112px", whiteSpace: "nowrap" },
    name: { minWidth: "320px", width: "320px", maxWidth: "320px" },
    unit: { minWidth: "88px", width: "88px", maxWidth: "88px", textAlign: "center" },
    price: { minWidth: "150px", width: "150px", maxWidth: "150px", textAlign: "center" },
    quantity: { minWidth: "150px", width: "150px", maxWidth: "150px" },
    action: { minWidth: "56px", width: "56px", maxWidth: "56px" },
} as const;

export const materialTableContainerStyle = { maxHeight: "none" };
